import { FamilyColumnMappingEntry } from './types';

/**
 * Builds the text content for the families import API from Excel data.
 * Format: -FamilyName / --SubFamilyName
 */
export function buildImportContent (
    rows: string[][],
    columnMappings: FamilyColumnMappingEntry[],
    headerRowNumber: number
): string {
    const familyColIndex = columnMappings.find(m => m.mappedField === 'family')?.excelColumnIndex;
    const subFamilyColIndex = columnMappings.find(m => m.mappedField === 'subFamily')?.excelColumnIndex;

    if (familyColIndex === undefined) {
        return '';
    }

    const dataRows = rows.slice(headerRowNumber);
    const lines: string[] = [];
    const emittedFamilies = new Set<string>();
    let currentFamily: string | null = null;

    for (const row of dataRows) {
        const familyName = row[familyColIndex]?.trim() ?? '';
        const subFamilyName = subFamilyColIndex !== undefined ? (row[subFamilyColIndex]?.trim() ?? '') : '';

        if (!familyName && !subFamilyName) continue;

        if (familyName && !emittedFamilies.has(familyName)) {
            lines.push(`-${familyName}`);
            emittedFamilies.add(familyName);
            currentFamily = familyName;
        } else if (familyName && familyName !== currentFamily) {
            currentFamily = familyName;
        }

        if (subFamilyName) {
            if (!currentFamily && !familyName) continue;
            lines.push(`--${subFamilyName}`);
        }
    }

    return lines.join('\n');
}
